import router from "@/router/index";
import cookies from "js-cookie";
import store from "@/store";

router.beforeEach((to, from, next) => {
    console.log(to);
  if (
    to.path == "/account/login" ||
    to.path == "/account/register" ||
    to.path == "/account/reset"
  ) {
    next();
  } else {
    var employee = cookies.getJSON("employee");
    if (employee != null) {
      console.log(store.getters);
      if (store.getters.menu.length <= 0) {
        store.dispatch("Menu", employee).then(e => {
          console.log(e);
          console.log(store.getters.defaultPage);
          if(to.path == '/'){
            next({ path: store.getters.defaultPage });
          }else{
            next();
          }
        });
      } else {
        console.log(111111111111);
        console.log(store.getters.defaultPage);
        // next({ path: store.getters.defaultPage});
        // next({ path: "/report/serviceorderreport" });
        if(to.path == '/'){
            next({ path: store.getters.defaultPage });
        }else{
            next();
        }
      }
    } else {
      next({ path: "/account/login" });
    }
  }
});



// WEBPACK FOOTER //
// ./src/config/filterRouter.js